import { ref } from "vue";
import { useAuthenticatedFetch } from "../auth/useAuthenticatedFetch";
import {
  PromoPack,
  PromoPackRequest,
  PromoPackSearchParams,
} from "@/interfaces/promoPack";
import { promopacks, clubUUID, paginationLinks, packs } from "@/shared/state";

const { authenticatedFetch } = useAuthenticatedFetch();
const API_URL = process.env.VUE_APP_ROOT_API;
export function usePromoPack() {
  const errorPromoPack = ref<boolean | false>(false);
  const isRequestPromoPack = ref<boolean | false>(false);
  const getPromoPacks = async () => {
    try {
      isRequestPromoPack.value = true;
      errorPromoPack.value = false;
      const response = await authenticatedFetch(
        `${API_URL}promo-packs/${clubUUID.value}`,
        {
          method: "GET",
        },
        false,
        "",
        false
      );
      promopacks.data = response?.data || [];
      isRequestPromoPack.value = false;
    } catch (err: any) {
      errorPromoPack.value = true;
      isRequestPromoPack.value = false;
    }
  };

  const fetchPromoPacks = async (body: PromoPackSearchParams) => {
    try {
      isRequestPromoPack.value = true;
      errorPromoPack.value = false;
      promopacks.data = [];
      paginationLinks.value = 0;
      const response = await authenticatedFetch(
        `${API_URL}promo-packs/search`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false
      );
      if (response) {
        if (body?.type === "paginate") {
          promopacks.data = response?.data?.data || [];
          paginationLinks.value = response?.data;
          delete paginationLinks.value.data;
        } else if (body?.type === "all") {
          promopacks.data = response?.data || [];
        }
        isRequestPromoPack.value = false;
      }
    } catch (err: any) {
      errorPromoPack.value = true;
      isRequestPromoPack.value = false;
    }
  };

  const addPromoPack = async (body: PromoPackRequest) => {
    try {
      isRequestPromoPack.value = true;
      errorPromoPack.value = false;
      const response = await authenticatedFetch(
        `${API_URL}promo-packs/store/${clubUUID.value}`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        true,
        "",
        true
      );
      if (response?.data) {
        const promoPackAdded: PromoPack = response?.data;
        promopacks?.data?.unshift(promoPackAdded);
        isRequestPromoPack.value = false;
      } else {
        isRequestPromoPack.value = false;
      }
    } catch (err: any) {
      errorPromoPack.value = true;
      isRequestPromoPack.value = false;
    }
  };

  const editPromoPack = async (body: PromoPackRequest) => {
    try {
      isRequestPromoPack.value = true;
      errorPromoPack.value = false;
      const response = await authenticatedFetch(
        `${API_URL}promo-packs/edit/${body?.id}/${clubUUID.value}`,
        {
          method: "PUT",
          body: JSON.stringify(body),
        },
        true,
        "",
        true
      );
      if (response?.data) {
        const promopackEdited: PromoPack = response?.data;
        const index = promopacks?.data?.findIndex(
          (PromoPack) => PromoPack?.id === promopackEdited?.id
        );
        if (index !== -1) {
          promopacks.data[index] = promopackEdited;
          location.reload();
        }
        isRequestPromoPack.value = false;
      } else {
        isRequestPromoPack.value = false;
      }
    } catch (err: any) {
      errorPromoPack.value = true;
      isRequestPromoPack.value = false;
    }
  };

  const deletePromoPack = async (id: number) => {
    try {
      isRequestPromoPack.value = true;
      errorPromoPack.value = false;
      const response = await authenticatedFetch(
        `${API_URL}promo-packs/delete/${id}/${clubUUID.value}`,
        {
          method: "DELETE",
        },
        true,
        "",
        true
      );
      const index = promopacks?.data?.findIndex(
        (PromoPack) => PromoPack?.id === id
      );
      if (index !== -1) {
        promopacks.data.splice(index, 1);
      }
      isRequestPromoPack.value = false;
    } catch (err: any) {
      errorPromoPack.value = true;
      isRequestPromoPack.value = false;
    }
  };

  return {
    getPromoPacks,
    addPromoPack,
    editPromoPack,
    deletePromoPack,
    isRequestPromoPack,
    errorPromoPack,
    fetchPromoPacks,
  };
}
